import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Header } from 'pages/Header';
import { Footer } from 'pages/Footer';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import "./style.sass";
import { useServices } from 'hooks/useServices';
import { useIsMobile } from 'hooks/useIsMobile';
import SlidersEmarsys from 'components/Emarsys/SlidersEmarsys/index_product';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { useHomePage } from 'hooks/useHomePage';
import { InputTypeAndroid } from 'components/Forms/InputType';
import { useForm } from 'react-hook-form';
import getTelmexStatus from 'services/getTelmexStatus';
import { ModalError } from 'components/Error/ErrorModal';
import { decodeStorage } from 'functions/storageBase64';
import { postClaroScore } from 'services/claroScore';
import getShipping from 'services/getShipping';
import { ClasicSelectTypeNew } from 'components/Forms/Select';
import { ProgressBar } from 'components/ProgressBar';
import { useStorage64 } from 'hooks/useStorageBase64';


export function PreguntaSinTelmex() {

    const history = useHistory();
    const { isMobile } = useIsMobile();
    
    const [, setInfoPreguntasSinTelmexStorage] = useStorage64('infoPreguntasSinTelmexStorage', '');

    //variables para modal de error
    const [errorCode, setErrorCode] = useState();
    const [messageResponse, setMessageResponse] = useState();
    const [sectionActive, setSectionActive] = useState("");
    const [showModalErr, setShowModalErr] = useState(false);
    const EXTERNO = decodeStorage('EXTERNO');

    // valida respuesta del servicio y si no pasa manda el error
    const handleCloseErr = () => {
        setShowModalErr(false);
        if (sectionActive === 'verificar') {
            window.location.href = `${BASE_PATH}`;
        }
    }

    const handleIrHomePortal = () => {
        // window.location.href = `${BASE_PATH}`;
        history.push(`${BASE_PATH}${SUB_DIRECTORY}solicitud-credito-claroshop/autorizar`);
    };

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.scrollTo(0, 0);
        window.ineum('page', 'Telmex  Credit-Page');
        window.ineum('meta', 'portal', 'Credito CS');
    }, [])

    const datosPersonalesStorage = decodeStorage("infoPersonalStorageIncode")
    const [datosPersonales, setDatosPersonales] = useState(datosPersonalesStorage);

    const [shipping, setShupping] = useState({});
    const [inputCalle, setInputCalle] = useState();
    const [inputCP, setInputCP] = useState(datosPersonales?.CPEmp);
    const [estado, setEstado] = useState();
    const [municipio, setMunicipio] = useState();
    const [ciudad, setCiudad] = useState();
    const [colonia, setColonia] = useState();
    const [inputAnioResidencia, setInputAnioResidencia] = useState();
    const [inputMesesResidencia, setInputMesesResidencia] = useState();

    const { register, handleSubmit, errors, clearErrors, reset } = useForm({
        defaultValues: {
            calle: datosPersonales.DireccionEmpleo,
            cp: datosPersonales.CPEmp,
            colonia: datosPersonales.colonia,
            municipio: datosPersonales.municipio,
            estado: datosPersonales.estado,
            ciudad: datosPersonales.ciudad,
            anioResidencia: datosPersonales.TiempoResAnio,
            mesesResidencia: datosPersonales.TiempoResMes
        }
    })

    const valTarjeta = {
        required: 'Campo obligatorio',
    };

    const valCreditoHipotecario = {
        required: 'Campo obligatorio',
    };

    const valCreditoAutomotriz = {
        required: 'Campo obligatorio',
    };
    
    const [tarjeta, setTarjeta] = useState(false);
    const seleccionartarjeta = (e) => {
        setTarjeta(e.target.value);
    }

    const [creditoHipotecario, setCreditoHipotecario] = useState(false);
    const seleccionarCreditoHipotecario = (e) => {
        setCreditoHipotecario(e.target.value);
    }

    const [creditoAutomotriz, setcreditoAutomotriz] = useState(false);
    const seleccionarCreditoAutomotriz = (e) => {
        setcreditoAutomotriz(e.target.value);
    }

     // consulta get Telmex
     const handleInformacionIne = data => {
        
        console.log("data form",data);

        setInfoPreguntasSinTelmexStorage({
            "STarjeta": data.tarjeta,
            "SHipotecario": data.creditoHipotecario,
            "SAutomotriz": data.creditoAutomotriz
        })

        history.push(`${BASE_PATH}${SUB_DIRECTORY}ultimos-pasos-creacion-nip`);

    }

    

    //useEffect(() => {
    //    if (returnForm === true) {
    //        setInfoPersonalStorage(datos);
    //        SetReturnForm(false);
    //        nextPage(2);
    //    }
    //}, [returnForm])


    // llenado de campos con cp
    useEffect(() => {
        if (inputCP) {
            if (inputCP.length === 5) {
                getShipping({ codigoPostal: inputCP })
                    .then(setShupping)
            }
            else if (inputCP.length < 5 || inputCP.length === 0) {
                setEstado('');
                setMunicipio('');
                setCiudad('');
                setColonia([]);
            }
        }
    }, [inputCP])

    useEffect(() => {
        if (shipping) {
            setEstado(shipping.estado);
            setMunicipio(shipping.municipio);
            setCiudad(shipping.ciudad);

            if (shipping?.code === 200) {
                clearErrors('estado');
                clearErrors("ciudad");
                clearErrors("colonia");
                clearErrors("municipio");
            }

            if (shipping.colonias) {
                if (shipping.colonias.length === 0) {
                    setColonia([]);
                }
                else if (shipping.colonias.length >= 1) {
                    setColonia(shipping.colonias);
                }
            }

            if (shipping?.code === 404) {
                setShowModalErr(true);
                setErrorCode(shipping?.code);
                setSectionActive('cp');
                setMessageResponse(shipping?.error);
            }
        }
    }, [shipping])



    return (
        <>
            <div className={isMobile === "desktop" ? "" : "homeMobile"}>
            {
                EXTERNO ? null : <HeaderMobileCredito title={"Solicitud de crédito ClaroShop"} type="backFull" />
            }
                <main className='nuevoCredito ultimosPasos'>
                    <ProgressBar progress={70} />
                    

                    <div className='contenidoSolicitarTarjeta fullBottom'>
                        <form onSubmit={handleSubmit(handleInformacionIne)}>
                            
                            <div className="viviendaBox telmex">
                                <p className="p-strong">¿Cuentas con tarjeta bancaria?</p>
                                <div className="subCampo">
                                    <ul className="ulTelmex" onChange={seleccionartarjeta}>
                                        <li>
                                            <input className="radio" id="tarjeta" type="radio" value="Si" name="tarjeta" ref={register(valTarjeta)} />
                                            <label name="tarjeta" htmlFor="tarjeta">Si </label>
                                        </li>
                                        <li>
                                            <input className="radio" id="tarjeta_2" type="radio" value="No" name="tarjeta" ref={register(valTarjeta)} />
                                            <label name="tarjeta_2" htmlFor="tarjeta_2">No </label>
                                        </li>
                                    </ul>
                                    <div className="secEmpleo">
                                        <div className="campo boxSexo errorTelmex">
                                            {tarjeta === false && errors.tarjeta && errors.tarjeta.message
                                                ? <div className="error">Campo obligatorio</div>
                                                : null
                                            }
                                        </div>
                                    </div>
                                </div>
                                
                                <p className="p-strong">¿Cuentas con un crédito hipotecario bancario?</p>
                                <div className="subCampo">
                                    <ul className="ulTelmex" onChange={seleccionarCreditoHipotecario}>
                                        <li>
                                            <input className="radio" id="creditoHipotecario" type="radio" value="Si" name="creditoHipotecario" ref={register(valCreditoHipotecario)} />
                                            <label name="creditoHipotecario" htmlFor="creditoHipotecario">Si </label>
                                        </li>
                                        <li>
                                            <input className="radio" id="creditoHipotecario_2" type="radio" value="No" name="creditoHipotecario" ref={register(valCreditoHipotecario)} />
                                            <label name="creditoHipotecario_2" htmlFor="creditoHipotecario_2">No </label>
                                        </li>
                                    </ul>
                                    <div className="secEmpleo">
                                        <div className="campo boxSexo errorTelmex">
                                            {creditoHipotecario === false && errors.creditoHipotecario && errors.creditoHipotecario.message
                                                ? <div className="error">Campo obligatorio</div>
                                                : null
                                            }
                                        </div>
                                    </div>
                                </div>

                                <p className="p-strong">¿Has ejercido algún crédito automotriz bancario en los últimos 24 meses?</p>
                                <div className="subCampo">
                                    <ul className="ulTelmex" onChange={seleccionarCreditoAutomotriz}>
                                        <li>
                                            <input className="radio" id="creditoAutomotriz" type="radio" value="Si" name="creditoAutomotriz" ref={register(valCreditoAutomotriz)} />
                                            <label name="creditoAutomotriz" htmlFor="creditoAutomotriz">Si </label>
                                        </li>
                                        <li>
                                            <input className="radio" id="creditoAutomotriz_2" type="radio" value="No" name="creditoAutomotriz" ref={register(valCreditoAutomotriz)} />
                                            <label name="creditoAutomotriz_2" htmlFor="creditoAutomotriz_2">No </label>
                                        </li>
                                    </ul>
                                    <div className="secEmpleo">
                                        <div className="campo boxSexo errorTelmex">
                                            {creditoAutomotriz === false && errors.creditoAutomotriz && errors.creditoAutomotriz.message
                                                ? <div className="error">Campo obligatorio</div>
                                                : null
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>
                    <div className="boxBtnSolicitar top">
                        <button className="btnSolicitar" onClick={handleSubmit(handleInformacionIne)}> Continuar</button>
                    </div>
                </main>
            </div>
        </>
    )
}